import { Component, Children } from 'react'
import PropTypes from 'prop-types'
import MQTT from 'mqtt'

export default class Connector extends Component {
  static propTypes = {
    mqqt: PropTypes.object,
    broker: PropTypes.string.isRequired,
    mqttProps: PropTypes.object,
    children: PropTypes.element.isRequired,
  }

  static childContextTypes = {
    mqtt: PropTypes.object,
    mqttStatus: PropTypes.string,
  }

  constructor(props, context) {
    super(props, context)

    const initialState = {}
    this.state = initialState
  }

  getChildContext() {
    return {
      mqtt: this.mqtt,
      mqttStatus: this.state.mqttStatus,
    }
  }

  UNSAFE_componentWillMount() {
    // eslint-disable-next-line react/prop-types
    const { broker, mqttProps, mqtt } = this.props

    this.mqtt = mqtt || MQTT.connect(broker, mqttProps)

    this.mqtt.on('connect', this._makeStatusHandler('connected'))
    this.mqtt.on('reconnect', this._makeStatusHandler('reconnect'))
    this.mqtt.on('close', this._makeStatusHandler('closed'))
    this.mqtt.on('offline', this._makeStatusHandler('offline'))
    this.mqtt.on('error', console.error)
    this.mqtt.on('packetreceive', (packet) => {
      if (packet.cmd === 'pingresp') {
        console.log('✅ mqtt: received PINGRESP from broker')
      }
    })
    this.mqtt.on('packetsend', (packet) => {
      if (packet.cmd === 'pingreq') {
        console.log('✅ mqtt: send PINGREQ to broker')
      }
    })
  }

  componentWillUnmount() {
    this.mqtt.end()
  }

  _makeStatusHandler = (status) => {
    return () => {
      console.log('mqtt:', status)
      this.setState({ mqttStatus: status })
    }
  }

  render() {
    return this.renderConnected()
  }

  renderConnected() {
    return Children.only(this.props.children)
  }
}
